import { formatNumber, getPhoneLink } from './phone';
import { IPhone } from '../../types/promoDetails';

export const preparePhones = (phones: IPhone[]) => {
  return phones
    .map(phone => ({
      number: formatNumber(phone) as string,
      link: getPhoneLink(phone) as string,
    }))
    .filter(phone => phone.number && phone.link);
};
